import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'pluck',
})
export class PluckPipe implements PipeTransform {
  transform(value: any, arrayToCompare: Array<any>, keyToCheck: any, keyToReturn: any, ...args: any[]): any {
    return arrayToCompare
      .map((obj) => {
        if (value == obj[keyToCheck]) {
          return obj[keyToReturn];
        }
      })
      .join('');
  }
}
